import React, { useEffect, useState } from 'react';
import Container from '../layout/Container';
import SectionTitle from '../ui/SectionTitle';
import ServiceCard from '../cards/ServiceCard';
import { publicApi } from '../../services/publicApi';

const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const loadServices = async () => {
      try {
        const data = await publicApi.getServiceOverviews();
        if (!isMounted) return;
        if (!Array.isArray(data) || data.length === 0) {
          setServices([]);
          return;
        }

        const mapped = data
          .filter((item) => item.isActive !== false)
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((item) => ({
            id: item.slug,
            title: item.title,
            icon: item.icon,
            description: item.shortDescription,
          }));
        setServices(mapped);
      } catch {
        if (isMounted) setServices([]);
      }
    };

    loadServices();
    return () => {
      isMounted = false;
    };
  }, []);

  if (services.length === 0) return null;

  return (
    <Container id="services" className="bg-white dark:bg-black transition-colors duration-300">
      <SectionTitle
        title="What We Do"
        subtitle="Our Services"
      />

      <div className="grid grid-cols-1 items-stretch gap-8 md:grid-cols-2 lg:grid-cols-3">
        {services.map((service, index) => (
          <ServiceCard key={service.id} service={service} index={index} />
        ))}
      </div>
    </Container>
  );
};

export default Services;
